import { format, parseISO } from 'date-fns';
import { enUS, es } from 'date-fns/locale';

import { Languages } from '~/localization/i18n';

/**
 * Formats a date-only string ("2026-03-16") for display. Date-only in, date-only
 * out — no timezone conversion, so server and client always agree.
 */
export function formatPostDate(isoDate: string, language: string) {
  const date = parseISO(isoDate);
  return language === Languages.ES
    ? format(date, "d 'de' MMMM 'de' yyyy", { locale: es })
    : format(date, 'MMMM d, yyyy', { locale: enUS });
}
